import React, { useEffect, useState } from "react";
import axios from "axios";
import baseURL from "../../config";
import Navbar from "../../Navbar/Navbar";
import ChargesForm from "./ChargesForm";
import ChargesDetails from "./ChargesDetails";
import { CircularProgress, Box } from "@mui/material";

const ChargesWrapper = () => {
  const [agentDetails, setAgentDetails] = useState(null);
  const [chargesDetails, setChargesDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const crewingAgentId = localStorage.getItem("urlID");

        const agentRes = await axios.get(
          `${baseURL}/api/getCrewingAgentsDetailsById/${crewingAgentId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setAgentDetails(agentRes.data);

        const chargesRes = await axios.get(
          `${baseURL}/api/getChargesDetailsByCrewingAgentId/${crewingAgentId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (chargesRes.data) {
          setChargesDetails(chargesRes.data);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <Box textAlign="center" mt={10}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Navbar />
      {chargesDetails ? (
        <ChargesDetails charges={chargesDetails} agentDetails={agentDetails} />
      ) : (
        <ChargesForm
          agentDetails={agentDetails}
          onSuccess={(data) => setChargesDetails(data)} // ✅ refresh after save
        />
      )}
    </>
  );
};

export default ChargesWrapper;
